import { Component } from '@angular/core';
import { DiscountedProductOfferingComponent } from '../../../discountedproductoffering/discounted-product-offering.component';
import { DiscountedPackageOfferingComponent } from '../../../discountedpackageoffering/discounted-package-offering.component';
import { OnSaleProductsComponent } from "../../../onsaleproducts/onsaleproducts.component";

@Component({
    selector: 'pf-specialoffer',
    templateUrl: './specialoffer.component.html',
    styleUrls: ['./specialoffer.component.scss'],
    standalone: true,
    imports: [DiscountedProductOfferingComponent, DiscountedPackageOfferingComponent, OnSaleProductsComponent]
})
export class SpecialofferComponent { }
